<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div
          v-show="stateArrow"
          id="leftBox"
          class="leftBox"
          style="width: 206px"
        >
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <el-scrollbar>
              <tree
                :isSearch="isSearch"
                @initFun="initQuery"
                @nodeClick="nodeClick"
              ></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i
            :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"
          ></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('common.driverNum')">
                    <el-input
                      size="mini"
                      v-model="formInline.driverNum"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('common.driverName')">
                    <el-input
                      size="mini"
                      v-model="formInline.driverName"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('DriverManagement.keyNum')">
                    <el-input
                      size="mini"
                      v-model="formInline.keyNum"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('DriverManagement.authorizePower')">
                    <el-select
                      v-model="formInline.authorizePower"
                      :label="$t('DriverManagement.form.authorizePower') + ':'"
                      filterable
                      size="mini"
                      style="width: 120px; margin-left: 5px"
                    >
                      <el-option :label="$t('common.all')" value=""></el-option>
                      <el-option
                        :label="$t('DriverManagement.normalPeople')"
                        value="1"
                      ></el-option>
                      <el-option
                        :label="$t('DriverManagement.adminPeople')"
                        value="0"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('DriverManagement.makeKeyTime')">
                    <el-date-picker
                      v-model="formInline.FactoryTime"
                      type="daterange"
                      style="width: 220px"
                      size="mini"
                      value-format="yyyy-MM-dd"
                      range-separator
                      :start-placeholder="$t('common.choseTime')"
                      end-placeholder
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{ $t("common.btn.search") }}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del">{{
                      $t("common.btn.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button
                  v-if="isPrimaryKey('KEYFILE_MAKEKEY')"
                  type="text"
                  @click="addKey"
                  :disabled="selected.length != 1"
                  >{{ $t("DriverManagement.makeKey") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('KEYFILE_DOWN')"
                  type="text"
                  @click="downKey"
                  >{{ $t("common.btn.download") }}</el-button
                >
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="700px"
        :before-close="closeDia"
        class="addDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="driverNum"
            :label="$t('common.driverNum') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              :disabled="disabled"
              v-model="form.driverNum"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="keyNum"
            :label="$t('DriverManagement.keyNum') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.keyNum"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('DriverManagement.authorizeType')"
            :label-width="formLabelWidth"
            prop="authorizePower"
          >
            <el-select
              v-model="form.authorizePower"
              :placeholder="$t('DriverManagement.form.choseAuthType')"
            >
              <el-option
                :label="$t('DriverManagement.normalPeople')"
                value="1"
              ></el-option>
              <el-option
                :label="$t('DriverManagement.adminPeople')"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="terminalId"
            :label="$t('common.terminalId') + ':'"
            :label-width="formLabelWidth"
          >
            <el-autocomplete
              size="small"
              v-model="form.terminalId"
              :fetch-suggestions="querySearch"
              @select="handleSelect"
              autocomplete="off"
            ></el-autocomplete>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import KeyFile from "./KeyFile.js";
export default KeyFile;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
